import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, defineAsyncComponent, type Component } from "vue";

export type FiloxeniaIconName =
  | "AlarmClock"
  | "ArrowBack"
  | "AutoAwesome"
  | "Close"
  | "Concierge"
  | "CoPresent"
  | "DisplaySettings"
  | "Guitar"
  | "Language"
  | "Map"
  | "MenuBook"
  | "MixArrows"
  | "Movie"
  | "Person"
  | "Restaurant"
  | "Visibility"
  | "Wifi"
  | "QueueMusic"
  | "QueueMusicMono"
  | "RecentActors"
  | "Search"
  | "Speaker"
  | "SpeakerIcon"
  | "SettingsInputComposite"
  | "LightModeOutline"
  | "LiveTv"
  | "NightsStayOutline"
  | "WeatherSunrise"
  | "WeatherSunset"
  | "WbTwilight"
  | "MusicNote"
  | "Lamp"
  | "LightCircuit"
  | "LightMode"
  | "Mode"
  | "NightsStay"
  | "PowerSettingsNew"
  | "Coffee"
  | "SoupKitchen"
  | "BrunchDining"
  | "LocalBar"
  | "VideoSettings";


export default /*@__PURE__*/_defineComponent({
  __name: 'FiloxeniaIcon',
  props: {
    name: {}
  },
  setup(__props: any) {



const iconMap: Record<FiloxeniaIconName, () => Promise<{ default: Component }>> = {
  AlarmClock: () => import("./Filoxenia/AlarmClock.vue"),
  ArrowBack: () => import("./Filoxenia/ArrowBack.vue"),
  AutoAwesome: () => import("./Filoxenia/AutoAwesomeIcon.vue"),
  Close: () => import("./Filoxenia/CloseIcon.vue"),
  Concierge: () => import("./Filoxenia/ConciergeIcon.vue"),
  CoPresent: () => import("./Filoxenia/CoPresent.vue"),
  DisplaySettings: () => import("./Filoxenia/DisplaySettings.vue"),
  Guitar: () => import("./Filoxenia/GuitarIcon.vue"),
  Language: () => import("./Filoxenia/LanguageIcon.vue"),
  Map: () => import("./Filoxenia/MapIcon.vue"),
  MenuBook: () => import("./Filoxenia/MenuBook.vue"),
  MixArrows: () => import("./Filoxenia/MixArrowsIcon.vue"),
  Movie: () => import("./Filoxenia/MovieIcon.vue"),
  Person: () => import("./Filoxenia/PersonIcon.vue"),
  Restaurant: () => import("./Filoxenia/RestaurantIcon.vue"),
  Visibility: () => import("./Filoxenia/VisibilityIcon.vue"),
  Wifi: () => import("./Filoxenia/WifiIcon.vue"),
  QueueMusic: () => import("./Filoxenia/QueueMusicIcon.vue"),
  QueueMusicMono: () => import("./Filoxenia/QueueMusicIconMono.vue"),
  RecentActors: () => import("./Filoxenia/RecentActorsIcon.vue"),
  Search: () => import("./Filoxenia/SearchIcon.vue"),
  Speaker: () => import("./Filoxenia/SpeakerIcon.vue"),
  SettingsInputComposite: () => import("./Filoxenia/SettingsInputComposite.vue"),
  SpeakerIcon: () => import("./Filoxenia/SpeakerIcon.vue"),
  LightModeOutline: () => import("./Filoxenia/LightModeOutline.vue"),
  LiveTv: () => import("./Filoxenia/LiveTvIcon.vue"),
  NightsStayOutline: () => import("./Filoxenia/NightsStayOutline.vue"),
  WeatherSunrise: () => import("./Filoxenia/WeatherSunrise.vue"),
  WeatherSunset: () => import("./Filoxenia/WeatherSunset.vue"),
  WbTwilight: () => import("./Filoxenia/WbTwilight.vue"),
  VideoSettings: () => import("./Filoxenia/VideoSettings.vue"),
  MusicNote: () => import("./Filoxenia/MusicNote.vue"),
  Lamp: () => import("./Filoxenia/LampIcon.vue"),
  LightCircuit: () => import("./Filoxenia/lightCircuit.vue"),
  LightMode: () => import("./Filoxenia/LightMode.vue"),
  Mode: () => import("./Filoxenia/ModeIcon.vue"),
  NightsStay: () => import("./Filoxenia/NightsStay.vue"),
  PowerSettingsNew: () => import("./Filoxenia/PowerSettingsNew.vue"),
  Coffee: () => import("./Filoxenia/CoffeeIcon.vue"),
  SoupKitchen: () => import("./Filoxenia/SoupKitchen.vue"),
  BrunchDining: () => import("./Filoxenia/BrunchDining.vue"),
  LocalBar: () => import("./Filoxenia/LocalBar.vue"),
};

const icon = computed(() => {
  const loader = iconMap[__props.name];
  if (!loader) {
    console.warn(`[FiloxeniaIcon] Icon "${__props.name}" not found`);
    return null;
  }
  return defineAsyncComponent(loader);
});

return (_ctx: any,_cache: any) => {
  return (icon.value)
    ? (_openBlock(), _createBlock(_resolveDynamicComponent(icon.value), _mergeProps({ key: 0 }, _ctx.$attrs, {
        class: ['icon', `icon-${__props.name.toLowerCase()}`]
      }), null, 16, ["class"]))
    : _createCommentVNode("", true)
}
}

})